import { Routes } from '@angular/router';

export const orderHarnessRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./order-harness/order-harness.component').then(mod => mod.OrderHarnessComponent),
    },
];
